import React from 'react';
import _isNil from 'lodash/isNil';
import _head from 'lodash/head';

import LastMessagePresenter from './lastMessagePresenter';
import { Collections } from '../../../../../firebase/firestore/collections';
import { useCurrentUserProfile } from '../../../../../app/hooks/useCurrentUserProfile';
import { useQuerySnapshot } from '../../../../../firebase/firestore/hooks';
import { Query } from '../../../../../firebase/firestore/query/query';
import { CandidateAudit } from '../../../../../firebase/firestore/documents/candidateAudit';
import { OrderByDirection } from '../../../../../firebase/firestore/query/criteria';
import { CandidateMessagingActionName } from '../../../../../firebase/firestore/documents/candidateAuditActionNames';

const useLastMessage = (candidateId: string): LastMessagePresenter => {
  const { currentUserProfile } = useCurrentUserProfile();
  const [lastMessage, setLastMessage] = React.useState<LastMessagePresenter>(new LastMessagePresenter());

  const query = React.useMemo(() => {
    return [
      Query.field<CandidateAudit>('candidateId').equals(candidateId),
      Query.field<CandidateAudit>('action').in([
        CandidateMessagingActionName.SEEKER_MESSAGE,
        CandidateMessagingActionName.EMPLOYER_MESSAGE,
      ]),
      Query.field<CandidateAudit>('account').equals(currentUserProfile?.account),
      Query.orderBy<CandidateAudit>('timestamp', OrderByDirection.desc),
      Query.limit(1),
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidateId, currentUserProfile?.account]);

  const candidateAudits = useQuerySnapshot<CandidateAudit>(Collections.CANDIDATE_AUDIT, query);

  React.useMemo(() => {
    // let initialized = false;

    if (candidateAudits) {
      const candidateAudit = _head(candidateAudits);
      if (!_isNil(candidateAudit)) {
        setLastMessage(new LastMessagePresenter(candidateAudit.id, candidateAudit.message));
      }
      // initialized = true;
    }

    // return { lastMessage, initialized };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidateAudits]);

  return lastMessage;
};

export default useLastMessage;
